import { useEffect, useRef } from 'react';

export default function AnimatedSeparator({ color = '#000', width = '100%' }) {
  const lineRef = useRef(null);

  useEffect(() => {
    const line = lineRef.current;
    if (!line) return;

    const check = () => {
      const rect = line.getBoundingClientRect();
      const inView =
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
      if (inView) {
        line.style.strokeDashoffset = '0';
      }
    };

    // Check on mount and on scroll
    check();
    window.addEventListener('scroll', check);
    return () => window.removeEventListener('scroll', check);
  }, []);

  return (
    <svg
      className="separator"
      width={width}
      height="2"
      viewBox="0 0 100 2"
      preserveAspectRatio="none"
    >
      <line ref={lineRef} x1="0" y1="1" x2="100" y2="1" stroke={color} strokeWidth="2" />
    </svg>
  );
}
